import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import app from './modules/app'
import auth from './modules/auth'
import images from './modules/images'
import users from './modules/users'

Vue.use(Vuex)

const authState = createPersistedState({
  paths: ['auth'],
  rehydrated: rehydrated
})

const store = new Vuex.Store({
  modules: {
    app,
    auth,
    images,
    users
  },
  plugins: [authState]
})

export default store

function rehydrated ({ getters, dispatch }) {
  const internalNumbers = getters['auth/allInternalNumbersMembers']
  for (const internalNumber of internalNumbers) {
    dispatch('images/downloadImage', internalNumber, { root: true })
  }
}
